


export default class SyncedList<T> {

    private list: T[];

    constructor() {
        this.list = [];
    }

    processData(data: any[]): void {
        for (const item of data) {
            switch (item.type.toLowerCase()) {
                case 'add':
                    this.list.push(item.object);
                    break;
                case 'remove':
                    this.list = this.list.filter(existingItem => (existingItem as any).id !== item.id);
                    break;
                case 'update':
                    const index = this.list.findIndex(existingItem => (existingItem as any).id === item.id);
                    if (index !== -1) {
                        this.list[index] = item.object;
                    }
                    break;
                default:
                    console.warn(`Unknown operation type: ${item.type}`);
            }
        }
    }

    getList(): T[] {
        return this.list;
    }

}